import React from "react";
import styles from "../Styles/AppInstall.module.css";
import userStyles from "../Styles/ViewOfUsersPages.module.css";
import authStyles from "../Styles/Auth.module.css";

const GOOGLE_DRIVE_LINK =
	"https://drive.google.com/drive/folders/1GWgDW-9X9VPWSlJe_NEDjeBVNJVfAqGL?usp=sharing";

const AppInstall = () => (
	<div
		className={userStyles.viewOfUsersContainer}
		style={{
			minHeight: "100vh",
			background: "var(--page-background)",
			// Removed overflowY: "auto" to prevent double scrollbars
		}}
	>
		<div className={userStyles.tableWrapper}>
			<h2 className={userStyles.pageTitle}>
				Download the MD Sensei Mobile App
			</h2>
			<p>
				<strong>Download the app for your phone:</strong>
			</p>
			<div className={styles.centerButtonWrapper}>
				<a
					href={GOOGLE_DRIVE_LINK}
					target="_blank"
					rel="noopener noreferrer"
					className={authStyles.alternateSubmitButton}
					style={{ maxWidth: 350, width: "100%" }}
				>
					Download App (Android &amp; iOS)
				</a>
			</div>
			<section className={styles.cardBox}>
				<h3>Android (APK)</h3>
				<ol>
					<li>
						Tap the download link above and download the file ending
						with <b>.apk</b>.
					</li>
					<li>
						If you see a warning, tap <b>Download anyway</b>.
					</li>
					<li>
						When the download finishes, tap the file to open it.
					</li>
					<li>
						If your phone says you can't install apps from this
						source, follow these steps:
						<ul>
							<li>
								Open your phone's <b>Settings</b> app.
							</li>
							<li>
								Tap <b>Apps</b> or{" "}
								<b>Apps &amp; Notifications</b>.
							</li>
							<li>
								Tap the three dots in the top-right corner. If
								you don't see them, skip to the next step.
							</li>
							<li>
								Tap <b>Special access</b> or{" "}
								<b>Special app access</b>.
							</li>
							<li>
								Tap <b>Install unknown apps</b>.
							</li>
							<li>
								Find and tap <b>Chrome</b> (or the browser or
								app you used to download), or{" "}
								<b>Files by Google</b> or <b>Google Drive</b> if
								you used those.
							</li>
							<li>
								Turn on <b>Allow from this source</b>.
							</li>
						</ul>
					</li>
					<li>
						Go back and tap <b>Install</b>.
					</li>
					<li>
						When finished, tap <b>Open</b> to use the app.
					</li>
				</ol>
				<div className={styles.infoBox}>
					<b>Tip:</b> After you click the download link on your
					Android phone, please be patient. It may take some time to
					download and install the app. Only click the link once.
				</div>
			</section>
			<section className={styles.cardBox}>
				<h3>Important Steps After Installing</h3>
				<ol>
					<li>
						When you first open the app, <b>sign up</b> and then{" "}
						<b>log in</b> at least once while you are connected to
						the internet.
					</li>
					<li>
						During sign up, for <b>Country</b> select <b>Malawi</b>.
						(Only Malawi has documentation. If you pick another
						country, the app will not work properly.)
					</li>
					<li>
						On the first loading page, the app will download all
						documents. <b>Please be patient</b>, this may take some
						time.
					</li>
					<li>
						When the documents are saved, you will see a message
						that you have logged in properly. Tap <b>OK</b>.
					</li>
					<li>
						After that, the Welcome page will appear. You can choose
						to chat with AI or with the Website service.
					</li>
				</ol>
			</section>
			<div className={styles.appInstallError}>
				<b>Note:</b> This app is distributed outside of the official app
				stores. Please only download and install apps from sources you trust.
			</div>
		</div>
	</div>
);

export default AppInstall;
